import { useEffect, useState } from 'react';
import config from '../../config';
import DashboardSidebar from './components/DashboardSidebar';
import Header from '../../components/Header';
import useAuth from '../../hooks/useAuth';
import { getRequest } from '@/services/api';
import InsurerTestRequests from './components/MedicalRecords/InsurerRequests';
import PhlebotomyRequests from './components/MedicalRecords/PhlebotomyRequests';
import BloodRequests from './components/MedicalRecords/BloodRequests';

const MedicalRecords = () => {
	const { user } = useAuth();
	const [activeTab, setActiveTab] = useState('insured');

	const [tabs, setTabs] = useState([]);

	useEffect(() => {
		let newTabs = [];

		const role = user?.account_role?.trim().toLowerCase();

		if (role === 'clinician') {
			// add 'Insured Test Requests', 'blood tests'
			newTabs = [
				{ key: 'insured', label: 'Insured Test Requests' },
				{ key: 'blood', label: 'Blood test Requests' },
			];
		} else if (role === 'company' || role === 'sole-trader' || role === 'sole-trader') {
			// add phlebotomy, insured customer, blood test requests
			newTabs = [
				{ key: 'insured', label: 'Insured Test Requests' },
				{ key: 'phlebotomy', label: 'Phlebotomy Requests' },
				{ key: 'blood', label: 'Blood test Requests' },
			];
		}

		setTabs(newTabs);
		setActiveTab(newTabs[0]?.key || '');
	}, [user]);

	return (
		<>
			<Header />
			<div className="container mt-25">
				<div className="row">
					<div className="col-md-5 col-lg-4 col-xl-3">
						<DashboardSidebar user={user} />
					</div>

					<div className="border-0 col-md-7 col-lg-8 col-xl-9">
						<div className="row">
							<div className=" card border-0 col-sm-12 d-flex flex-column gap-3">
								<div className="inline-flex text-center rounded-md shadow-xs" role="group">
									{tabs?.map((tab, index) => (
										<button
											key={tab.key}
											type="button"
											onClick={() => setActiveTab(tab.key)}
											className={`px-4 py-2 text-sm font-medium border border-gray-200 
												${index === 0 ? 'rounded-s-lg' : ''}
												${index === tabs.length - 1 ? 'rounded-e-lg' : ''}
												${
													activeTab === tab.key
														? 'bg-blue-600'
														: 'bg-white text-gray-900 hover:bg-gray-100 hover:text-blue-700'
												}`}
										>
											{tab.label}
										</button>
									))}
								</div>

								<div>
									{activeTab === 'insured' && <InsurerTestRequests user={user} />}
									{activeTab === 'phlebotomy' && <PhlebotomyRequests user={user} />}
									{activeTab === 'blood' && <BloodRequests user={user} />}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default MedicalRecords;
